document.addEventListener("DOMContentLoaded", () => {
  // NG Age Verification integration
  setTimeout(() => {
    let agpMessage = document.querySelector(".agp__message");
    if (agpMessage) {
      var newSVG = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "svg"
      );
      newSVG.setAttribute("width", "184");
      newSVG.setAttribute("height", "19");
      newSVG.setAttribute("fill", "none");
      newSVG.setAttribute("viewBox", "0 0 184 19");
      newSVG.innerHTML =
        '<path d="M0.994141 11.0113C32.0508 -4.41541 56.0267 21.8789 70.2063 7.09443C77.4475 -0.45576 62.1116 -1.22709 60.4455 12.5539C58.7795 26.335 119.897 5.0952 182.01 9.57159" stroke="#C8B4A0" stroke-linecap="round"/>';
      agpMessage.insertAdjacentElement("afterend", newSVG);
    }
  }, 300);

  // Paywhirl integration
  setTimeout(() => {
    let pwWidget = document.querySelector(".new-product .paywhirl-plan-selector");
    let customWidget = document.querySelector(".new-product__shipping");
    if (pwWidget && customWidget) {
      let oneTimePurchaseOption = pwWidget.querySelector("#paywhirl-one-time-purchase-group");
      if (oneTimePurchaseOption) {
        customWidget.querySelector(".new-product__pw-one-time input").setAttribute("checked", true);
        customWidget.querySelector(".new-product__pw-one-time").style.display = "block";
      }

      let subscriptionInfo = JSON.parse(pwWidget.getAttribute("data-product"))?.variants[0]?.selling_plan_allocations;
      let arrangedSubscriptionInfo = subscriptionInfo.reduce((acc, item) => {
          const groupId = item.selling_plan_group_id;
          if (!acc[groupId]) {
              acc[groupId] = [];
          }
          acc[groupId].push(item);
          return acc;
      }, {});
      let pwPlanGroups = pwWidget.querySelectorAll(".paywhirl-plan-selector-group");
      let html = "";
      let giftPlanHtml = "";
      let globalIndex = 0
      pwPlanGroups.forEach(s => {
        let paywhirlPlanSelectorGroupName = s.querySelector('label.paywhirl-label .paywhirl-plan-selector-group-name').innerHTML;
        if (paywhirlPlanSelectorGroupName.includes('Gift')) {
          let sellingPlanGroupId = s.closest('.paywhirl-plan-selector-group').getAttribute('data-group-id');
          let plans = s.querySelectorAll('select option');
          plans.forEach((plan, idx) => {
            let subscriptionPrice = "$" + (arrangedSubscriptionInfo[sellingPlanGroupId][idx].price / 100).toFixed(0);
            giftPlanHtml +=
            '<p class="new-product__pw-subscribe-option"><input type="radio" id="sub-opt-' + (globalIndex + 1) + '" name="pw-subscription"' + (globalIndex === 0 && ' checked') + '><label for="sub-opt-' +
            (globalIndex + 1) + '" data-plan-id="' + (arrangedSubscriptionInfo[sellingPlanGroupId][idx].selling_plan_id) + '">' + plan.innerHTML + " - " + subscriptionPrice + "</label></p>";
            globalIndex++;
          })
        } else {
          let sellingPlanGroupId = s.closest('.paywhirl-plan-selector-group').getAttribute('data-group-id');
          let plans = s.querySelectorAll('select option');
          plans.forEach((plan, idx) => {
            let subscriptionPrice = "$" + (arrangedSubscriptionInfo[sellingPlanGroupId][idx].price / 100).toFixed(0);
            html +=
            '<p class="new-product__pw-subscribe-option"><input type="radio" id="sub-opt-' + (globalIndex + 1) + '" name="pw-subscription"' + (globalIndex === 0 && ' checked') + '><label for="sub-opt-' +
            (globalIndex + 1) + '" data-plan-id="' + (arrangedSubscriptionInfo[sellingPlanGroupId][idx].selling_plan_id) + '">' + plan.innerHTML + " - " + subscriptionPrice + "</label></p>";
            globalIndex++;
          })
        }
      });

      document.querySelector(".new-product__pw-subscribe:not(.gift-subscription) .new-product__pw-subscribe-options").innerHTML = html;
      if (giftPlanHtml) {
        document.querySelector(".new-product__pw-subscribe.gift-subscription .new-product__pw-subscribe-options").innerHTML = giftPlanHtml;
        document.querySelector(".new-product__pw-subscribe.gift-subscription").style.display = "block";
      }
      customWidget.querySelector(".new-product__pw-container").style.display = "flex";

      let customOneTime = document.querySelector(".new-product__pw-one-time label");
      if (customOneTime) {
        customOneTime.addEventListener("click", () => {
          document
            .querySelector("#paywhirl-one-time-purchase-group label")
            .click();
        });
      }

      let customSubscribes = document.querySelectorAll(".new-product__pw-subscribe-option label");
      if (customSubscribes.length > 0) {
        customSubscribes.forEach(sub => {
          sub.addEventListener("click", () => {
            let planID = Number(sub.getAttribute("data-plan-id"));
            pwWidget.querySelectorAll(".paywhirl-plan-selector-group select option[value='" + planID + "']").selected = true;
            pwWidget
              .querySelector("input[name='selling_plan']")
              .setAttribute(
                "value",
                planID
              );

            let giftCheckbox = document.querySelector('input.gift-checkbox');
            if (giftCheckbox) {
              if (sub.closest('.new-product__pw-subscribe').classList.contains('gift-subscription')) {
                giftCheckbox.setAttribute('checked', 'checked');
              } else {
                giftCheckbox.removeAttribute('checked');
              }
            }
          });
        });
      }

      customSubscribes[0].click();
    }
  }, 1000);
});